module.exports = __webpack_public_path__ + "img/journey1-C.2886f8dc.png";